var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "tileHtmlContent" }, [
    _c("table", { staticClass: "executory-table" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.years.length
        ? _c(
            "tbody",
            _vm._l(_vm.years, function (y, i) {
              return _c("tr", { key: i }, [
                _c("td", { staticClass: "first-column" }, [
                  _c(
                    "button",
                    {
                      staticClass: "link-btn",
                      on: {
                        click: function ($event) {
                          return _vm.getInfo(y, "all")
                        },
                      },
                    },
                    [_vm._v(_vm._s(y))]
                  ),
                ]),
                _vm._v(" "),
                _vm.stat[y].opened.count_total
                  ? _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "link-btn",
                          on: {
                            click: function ($event) {
                              return _vm.getInfo(y, "opened")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.stat[y].opened.count_total))]
                      ),
                    ])
                  : _c("td", [_vm._v("—")]),
                _vm._v(" "),
                _vm.stat[y].closed.count_total
                  ? _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "link-btn",
                          on: {
                            click: function ($event) {
                              return _vm.getInfo(y, "closed")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.stat[y].closed.count_total))]
                      ),
                    ])
                  : _c("td", [_vm._v("—")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.moneyFormat(
                        (_vm.stat[y].opened.sum_total
                          ? _vm.stat[y].opened.sum_total
                          : 0) +
                          (_vm.stat[y].closed.sum_total
                            ? _vm.stat[y].closed.sum_total
                            : 0),
                        2
                      )
                    )
                  ),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("tfoot", [
        _c("tr", [
          _c("td", { staticClass: "first-column" }, [_vm._v("Все годы")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.stat.total.opened.count_total
                  ? _vm.stat.total.opened.count_total
                  : "—"
              )
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.stat.total.closed.count_total
                  ? _vm.stat.total.closed.count_total
                  : "—"
              )
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.moneyFormat(
                  (_vm.stat.total.opened.sum_total
                    ? _vm.stat.total.opened.sum_total
                    : 0) +
                    (_vm.stat.total.closed.sum_total
                      ? _vm.stat.total.closed.sum_total
                      : 0),
                  2
                )
              )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "first-column" }, [_vm._v("Год")]),
        _vm._v(" "),
        _c("th", [_vm._v("Открытые")]),
        _vm._v(" "),
        _c("th", [_vm._v("Оконченные")]),
        _vm._v(" "),
        _c("th", [
          _vm._v("Общая сумма, "),
          _c("i", { staticClass: "uk-icon-rub" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }